import { isEmbedMode } from './utils/embedContext'

function dispatchStoreEvent (storeId) {
  if (!storeId) return
  window.dispatchEvent(new CustomEvent('secure-travel:set-store', {
    detail: { storeId: Number(storeId) }
  }))
}

function dispatchAirportEvent (airport, terminal) {
  if (!airport) return
  window.dispatchEvent(new CustomEvent('secure-travel:set-airport', {
    detail: {
      airport: String(airport).toUpperCase(),
      terminal: terminal ? String(terminal).toUpperCase() : ''
    }
  }))
}

function initIframeResizerChild () {
  if (!isEmbedMode()) return

  try {
    require('iframe-resizer/js/iframeResizer.contentWindow')
  } catch (err) {
    console.warn('[booking-spa] iframe-resizer child unavailable', err)
  }
}

function initPostMessageBridge () {
  window.addEventListener('message', function (event) {
    var data = event.data
    if (!data || typeof data !== 'object') return

    if (data.type === 'secure-travel:set-store' && data.storeId) {
      dispatchStoreEvent(data.storeId)
    }

    if (data.type === 'secure-travel:set-airport' && data.airport) {
      dispatchAirportEvent(data.airport, data.terminal)
    }
  })
}

function initPublicApi () {
  window.SecureTravelBooking = {
    setStoreId: dispatchStoreEvent,
    setAirport: dispatchAirportEvent
  }
}

export function initEmbedBridge () {
  initIframeResizerChild()
  initPostMessageBridge()
  initPublicApi()
}



// WEBPACK FOOTER //
// ./src/embedBridge.js